import React from 'react';
import { Grid, Paper, Typography, Box } from '@mui/material';
import PeopleIcon from '@mui/icons-material/People';
import SchoolIcon from '@mui/icons-material/School';
import ContactMailIcon from '@mui/icons-material/ContactMail';

function DashboardHome() {
  return (
    <div>
      <Typography variant="h4" gutterBottom>
        Dashboard Overview
      </Typography>
      
      {/* Stats Cards */}
      <Grid container spacing={3} sx={{ mb: 4 }}>
        <Grid item xs={12} sm={4}>
          <Paper
            sx={{
              p: 3,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              bgcolor: 'primary.light',
              color: 'white',
            }}
          >
            <PeopleIcon sx={{ fontSize: 40, mb: 1 }} />
            <Typography variant="h4">150</Typography>
            <Typography variant="subtitle1">Total Students</Typography>
          </Paper>
        </Grid>
        
        <Grid item xs={12} sm={4}>
          <Paper
            sx={{
              p: 3,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              bgcolor: 'secondary.light',
              color: 'white',
            }}
          >
            <SchoolIcon sx={{ fontSize: 40, mb: 1 }} />
            <Typography variant="h4">12</Typography>
            <Typography variant="subtitle1">Active Courses</Typography>
          </Paper>
        </Grid>
        
        <Grid item xs={12} sm={4}>
          <Paper
            sx={{
              p: 3,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              bgcolor: 'success.light',
              color: 'white',
            }}
          >
            <ContactMailIcon sx={{ fontSize: 40, mb: 1 }} />
            <Typography variant="h4">25</Typography>
            <Typography variant="subtitle1">New Enquiries</Typography>
          </Paper>
        </Grid>
      </Grid>

      {/* Recent Activities */}
      <Paper sx={{ p: 3 }}>
        <Typography variant="h6" gutterBottom>
          Recent Activities
        </Typography>
        <Box>
          {/* Activity items */}
          <Box sx={{ py: 2, borderBottom: '1px solid #eee' }}>
            <Typography variant="subtitle1" color="primary">
              New Course Registration
            </Typography>
            <Typography variant="body2" color="text.secondary">
              John Doe registered for Advanced Web Development
            </Typography>
          </Box>
          
          <Box sx={{ py: 2, borderBottom: '1px solid #eee' }}>
            <Typography variant="subtitle1" color="primary">
              New Enquiry
            </Typography>
            <Typography variant="body2" color="text.secondary">
              New enquiry received for Machine Learning Course
            </Typography>
          </Box>
          
          <Box sx={{ py: 2 }}>
            <Typography variant="subtitle1" color="primary">
              Course Updated
            </Typography>
            <Typography variant="body2" color="text.secondary">
              React Development course curriculum updated
            </Typography>
          </Box>
        </Box>
      </Paper>
    </div>
  );
}

export default DashboardHome;
